<template>
  <div class="section">
    <div class="swiper mySwiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <div class="section section1">
            <div class="main_content banner1">
              <img src="../../assets/join_logo.png" alt="" />
              <p>每一度，我们在服务</p>
            </div>
          </div>
        </div>

        <div class="swiper-slide">
          <div class="section10">
            <div class="main_content">
              <div class="title">
                <div class="div1 white">宣传视频</div>
                <div class="div2 white_gradient1">Promotional video</div>
                <span class="line"></span>
              </div>
              <div style="margin-top:40px;" class="videoPlay">
                <video autoplay loop controls preload>
                  <source src="https://file.smalleel.com//2023/08/28/%E8%BE%B0%E9%B3%97%E7%A7%91%E6%8A%808.25V3.m4v">
                </video>
              </div>
            </div>
          </div>
        </div>

        <div class="swiper-slide">
          <div class="section section2">
            <div class="main_content">
              <div class="title">
                <div class="div1 white">人才理念</div>
                <div class="div2 white_gradient1">TALENT CONCEPT</div>
                <span class="line"></span>
              </div>
              <div class="section2_content white">
                <p>
                  辰鳗始终倡导开放、透明、无等级的沟通、无障碍的交流.
                </p>
                <p class="mt28">
                  欢迎充满活力、永怀理想、坚持奋斗、追求不凡的你，成为未来的辰鳗事业合伙人。
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="section section3">
            <div class="main_content">
              <div class="title">
                <div class="div1 black">公司福利</div>
                <div class="div2 black_gradient">CORPORATE WELFARE</div>
                <span class="line"></span>
              </div>

              <img src="../../assets/welfare.png" alt="" class="welfare_img" />

              <!-- <div class="section3_content">
            <img src="../../assets/join_img1.png" alt="" />
              <div class="right_box">
              <div class="item_wrap">
                <img src="../../assets/join_icon1.png" class="icon" alt="" />
                <div class="item">
                  <p class="h1">环境</p>
                  <p class="h2">
                    舒适宽松的办公环境，无限量供应零食，鼓励员工劳逸结合。
                  </p>
                </div>
              </div>
              <div class="item_wrap">
                <img src="../../assets/join_icon2.png" class="icon" alt="" />
                <div class="item">
                  <p class="h1">年会</p>
                  <p class="h2">
                    每年年底举行的年会是辰鳗最重要的盛会之一，年会上，向员工传递公司战略、业务布局与管理思路，并表彰优秀团队。
                  </p>
                </div>
              </div>
              <div class="item_wrap">
                <img src="../../assets/join_icon3.png" class="icon" alt="" />
                <div class="item">
                  <p class="h1">不定期团建</p>
                  <p class="h2">
                    自公司创立以来，每个季度至少一次团建,全体员工欢聚一堂,做游戏、BBQ、生日趴等,增进员工感情，提升团队凝聚力。
                  </p>
                </div>
              </div>
            </div>
          </div> -->
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="section section4">
            <div class="main_content">
              <div class="title">
                <div class="div1 white">招聘岗位</div>
                <div class="div2 white_gradient">RECRUITMENT</div>
                <span class="line"></span>
              </div>
              <div class="section4_content">
                <div class="main1" @click="goDetail">
                  <p>
                    JOIN US
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-scrollbar"></div>
    </div>
  </div>
</template>
<script>
import "swiper/dist/css/swiper.css"
import Swiper from 'swiper';
import { EventBus } from "@/untils/eventBus";

export default {
  data () {
    return {

    }
  },
  mounted () {
    this.initSwiper()
  },
  methods: {
    goDetail(){
      this.$router.push("/joinUs2");
      EventBus.$emit("index", 5);
    },
    initSwiper () {
      var swiper = new Swiper(".mySwiper", {
        direction: "vertical",
        effect: 'fade',
        slidesPerView: 1,
        observeParents: true,
        initialSlide: 0,
        spaceBetween: 30,
        mousewheel: {
          thresholdTime: 2000,
          thresholdDelta: 120
        },
        forceToAxis: true,
        scrollbar: {
          el: '.swiper-scrollbar',
        },
        preventClicks: false,
        preventClicksPropagation: false
      });
    },

  }
};
</script>
<style scoped lang="scss">
@import '../../assets/style/join.scss';
.white_gradient1 {
  background-image: linear-gradient(60deg, #fff 20%, #b7b8b8);
  background-clip: text;
}
.section1 {
  background: url('https://file.smalleel.com/2023/08/28/1693187138BP3do.png') no-repeat;
  background-position: center;
  background-size: cover;
}
.section2 {
  background: url('../../assets/join_bg2.png') no-repeat;
  background-position: center;
  background-size: cover;
}

.section10{
  background: url('../../assets/join_bg4.png');
  height: 100%;
}
.section3 {
  background: url('../../assets/join_bg3.png') no-repeat;
  background-position: center;
  background-size: cover;
}
.section4 {
  background: url('../../assets/join_bg4.png');
  background-position: center;
  background-size: cover;
}

.banner1 {
  padding-top: 236px;
  img {
    width: 160px;
    height: 64px;
  }
  p {
    font-size: 40px;
    font-family: 'PangMenZhengDao';
    font-weight: 400;
    color: #ffffff;
    margin-top: 60px;
  }
}
.title {
  text-align: left;
  padding-top: 96px;
  display: flex;
  align-items: baseline;
  .div1 {
    font-size: 60px;
    font-family: 'PangMenZhengDao';
    font-weight: 400;
    letter-spacing: 6px;
  }
  .div2 {
    font-size: 24px;
    font-family: 'PangMenZhengDao';
    font-weight: 400;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-left: 24px;
  }
  .line {
    display: block;
    width: 5px;
    height: 16px;
    background: #3170ff;
    margin-left: 10px;
  }
}

.section2_content {
  margin-top: 237px;
  p {
    font-size: 18px;
    font-family: 'Regular';
    font-weight: 400;
    line-height: 20px;
  }
}
.section3_content {
  display: flex;
  margin-top: 80px;

  img {
    width: 480px;
    height: 500px;
  }
  .right_box {
    width: 100%;
    height: 500px;
    background: linear-gradient(90deg, #3170ff, #ffffff);
  }
}

.section4_content {
  background: url('../../assets/join_img2.png') no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 580px;
  margin-top: 77px;
  display: flex;
  justify-content: center;
  align-items: center;
  .main1 {
    width: 120px;
    cursor: pointer;
    margin-top: 10rem;
    padding: 10px 15px;
    border-radius: 20px;
    border: 1px solid #fff;
    line-height: 120px;
    // background: #14171b;
    // opacity: 0.6;
    text-align: center;
    align-items: center;
    color: #ffffff;
  }
}

.item_wrap {
  position: relative;
  text-align: left;
  .item {
    display: flex;
    height: 110px;
    width: 500px;
    background: #3b80ff;
    margin-top: 55px;
    padding-left: 70px;
    flex-direction: column;
    box-sizing: border-box;
  }
  .icon {
    width: 80px;
    height: 80px;
    position: absolute;
    left: -40px;
    top: 15px;
  }
  .h1 {
    font-size: 18px;
    font-family: 'Medium';
    font-weight: 500;
    color: #fdfeff;
    line-height: 30px;
    margin-top: 30px;
  }
  .h2 {
    font-size: 14px;
    font-family: 'Regular';
    font-weight: 400;
    color: #fdfeff;
    line-height: 20px;
  }
}
.welfare_img {
  width: 1200px;
  height: 500px;
  margin-top: 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/join.vue